import styled from 'styled-components';

export const ButtonMLStyled = styled.div`
  .primary {
    button {
      background-color: ${(props) => {
        return props.theme[props.brand].btn.bgColor;
      }};
      color: ${(props) => props.theme[props.brand].btn.color} !important;
      font-size: ${(props) => props.fontsize} !important;
      width: ${(props) => props.width} !important;
      /* height: ${(props) => props.height} !important; */
      padding: 6px 20px !important;
      border: none;
    }
    button:hover {
      border: none;
      box-shadow: 1px 1px 5px ${(props) => props.theme[props.brand].btn.bgColor} !important;
    }
    .ant-btn:hover,
    .ant-btn:focus,
    .ant-btn:active,
    .ant-btn.active {
      background: ${(props) => props.theme[props.brand].btn.hoverColor};
      border-color: ${(props) => props.theme[props.brand].btn.bgColor};
    }
    button:hover {
      border: none;
    }
    .ant-btn-lg {
      border-radius: 0;
    }
    .ant-btn-round.ant-btn-lg {
      border-radius: 0;
    }
    .ant-btn[disabled] {
      background-color: ${(props) => {
        return props.theme[props.brand].btn.bgColor;
      }};
    }
  }
  .link {
    overflow-x: hidden;

    button {
      color: ${(props) => props.theme[props.brand].btn.bgColor} !important;
      font-size: ${(props) => props.fontsize} !important;
      width: ${(props) => props.width} !important;
      height: ${(props) => props.height} !important;
      padding: 6px 20px !important;
      border: none;
    }
    button:hover {
      border: none;
    }
    button:hover {
      border: none;
    }
    .ant-btn-lg {
      border-radius: 0;
    }
    .ant-btn-round.ant-btn-lg {
      border-radius: 0;
    }
    .ant-btn[disabled] {
      /* background: #cf8388; */
      background: ${(props) => props.theme[props.brand].btn.disabledColor};
    }
  }
  .default {
    button {
      width: ${(props) => props.width} !important;
      /* height: ${(props) => props.height} !important; */
      padding: 6px 20px !important;
    }
    button:hover {
      color: ${(props) => props.theme[props.brand].btn.bgColor};
      border-color: ${(props) => props.theme[props.brand].btn.bgColor};
      box-shadow: 1px 1px 5px ${(props) => props.theme[props.brand].btn.bgColor} !important;
    }
  }
  .anticon-down {
    font-size: 11px !important;
  }
  .ant-btn[disabled] {
    background: ${(props) =>
      props.theme[props.brand].btn.disabledBg} !important;
    &:hover {
      border: none !important;
      box-shadow: none !important;
    }
  }
`;
